import { Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useShare, type ShareTarget } from "@/hooks/useShare";
import type { FavoriteKind } from "@/lib/favorites/types";

interface ShareButtonProps {
  kind: "place" | "activity" | "producer" | "accommodation";
  slug?: string | null;
  title: string;
  className?: string;
  size?: "sm" | "default";
}

const KIND_TO_SHARE: Record<string, ShareTarget["kind"]> = {
  place: "place",
  producer: "producer",
  activity: "place", // activities use place share for now
  accommodation: "accommodation",
};

export function ShareButton({ kind, slug, title, className, size = "sm" }: ShareButtonProps) {
  const { share } = useShare();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    if (!slug) return;

    if (kind === "producer") {
      share({ kind: "producer", slug, name: title });
    } else if (kind === "accommodation") {
      share({ kind: "accommodation", id: slug, name: title });
    } else {
      share({ kind: "place", slug, name: title });
    }
  };

  if (!slug) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      className={`h-9 w-9 rounded-full bg-background/80 backdrop-blur-sm hover:bg-background/90 ${className ?? ""}`}
      onClick={handleClick}
      aria-label={`Dela ${title}`}
    >
      <Share2 className={size === "sm" ? "h-4 w-4" : "h-5 w-5"} />
    </Button>
  );
}
